import styled, { css } from 'styled-components';

export const PageExperimentWrapper = styled.div`
  display: grid;
  width: 100%;
`

export const ABContainer = styled.div<{ visible: boolean }>`
  width: 100%;
  grid-row: 1 / 2;
  grid-column: 1 / 2;

  ${({ visible }) => !visible ? css`
    opacity: 0;
    pointer-events: none;
  ` : ''};
`
